module.exports = __webpack_public_path__ + "static/media/guidelineGrid.be6fc1f6.jpg";